import { forwardRef } from 'react';
import { useGlobalState } from '../../App/globalState';
import ButtonWrapper from './style/buttonWrapper';
import IconButtonWrapper from './style/iconButtonWrapper';

const Button = forwardRef((props, ref) => {
  const { children, type, icon, negativeAction, ...restProps } = props;
  const { globalState } = useGlobalState();
  const { language } = globalState || {};

  if (type === 'icon') {
    return (
      <IconButtonWrapper
        {...restProps}
        onClick={(e) => {
          e.preventDefault();
          restProps.onClick && restProps.onClick();
        }}
        ref={ref}
      >
        {icon}
      </IconButtonWrapper>
    );
  }

  return (
    <ButtonWrapper
      $negativeAction={negativeAction}
      {...restProps}
      type={type}
      $language={language}
      ref={ref}
    >
      {children}
    </ButtonWrapper>
  );
});

Button.displayName = 'Button';
export default Button;
